<template>
  <div class="borrowerAttributeStates">
    <BorrowerAttributeConstructor
      :questionText="questionText"
      :description="description"
      :descriptionTooltip="descriptionTooltip"
      :tooltipText="tooltipText"
      :errorText="errorText"
      :helpText="helpText"
      :disclaimer="disclaimer">
      <template v-slot:input>
        <div class="form-floating ba-states">
          <select
            :name="'ba' + question.id"
            :id="'ba' + question.id"
            class="form-control form-select"
            :aria-label="label"
            :data-cy="question.alias"
            :dreams-id="question.alias"
            :class="{'no-value-select': !value, 'is-invalid': v$.value && v$.value.$error}"
            :disabled="disabled"
            :required="question.required"
            placeholder="State"
            v-model="value"
            @blur="onBlur(v$, $event)"
            @change="onChange(v$, $event)"
            @click="setShowLabel(true)"
          >
            <option :value="null" disabled selected>What state is your business in?</option>
            <option
              v-for="(state, i) in states"
              :value="state.value"
              :key="i">
              {{ state.label }}
            </option>
          </select>
          <label v-if="value || showLabel" :for="'ba' + question.id"><span>What state is your business in?</span></label>
          <div class="mb-2 invalid-feedback" :class="{'d-block': v$.$error}"><i class="fa-light fa-circle-exclamation"></i> Please select an option</div>
        </div>
      </template>
    </BorrowerAttributeConstructor>
  </div>
</template>

<script>
  import { lsUtils } from '../../libs/ls-utils-service'
  import { useVuelidate } from '@vuelidate/core'
  import { required } from '@vuelidate/validators'
  import get from 'lodash/get'
  import BorrowerAttributeConstructor from './BorrowerAttributeConstructor.vue'

  export default {
    setup: () => ({ v$: useVuelidate() }),
    data () {
      return {
        value: '',
        states: lsUtils.getUsStateOptions(),
        showLabel: null,
      }
    },
    props: {
      question: Object,
      disabled: Boolean,
      v: Object
    },
    emits: ['invalidity', 'answer'],
    components: {
      BorrowerAttributeConstructor,
    },
    computed: {
      invalid() {
        return this.v$.$invalid
      },
      questionText() {
        return this.question.questionText || ''
      },
      description() {
        return this.question.description || ''
      },
      descriptionTooltip() {
        return this.question.descriptionTooltip || ''
      },
      label() {
        return this.question.name || ''
      },
      tooltipText() {
        return this.question.tooltip || this.question.helpText || ''
      },
      helpText() {
        return this.question.tooltip ? this.question.helpText : ''
      },
      errorText() {
        return get(this.v$, 'value.$error') ? this.errorMessage : ''
      },
      disclaimer() {
        return this.question.disclaimer || ''
      },
    },
    created () {
      this.$watch('invalid', (invalid) => {
        this.$emit('invalidity', invalid)
      }, {immediate: true})

      this.value = this.question.value || null
    },
    validations: function () {
      return {
        value: { required: required }
      }
    },
    methods: {
      onBlur (v$, e) {
        !this.value && this.setShowLabel(false)
        v$.$touch()
      },
      onChange (v$, e) {
        v$.$touch()
        this.$emit('answer', { value: e.target.value, isInvalid: v$.$invalid, submitImmediately: true })
      },
      setShowLabel (payload) {
        this.showLabel = payload
      }
    }
  }
</script>

<style scoped lang="scss">
.ba-states {
  label {
    color: $type-400
  }
}
</style>
